export interface RecipeProductType {
  id:number;
  name: string;
  productType: number;
  countryId: number;
}

export function createDefaultProductType(): RecipeProductType {
  return {
    id: 0,
    name: '',
    productType: 0,
    countryId: 0
  };
}